import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9.99255 5.41445L10.1034 5.60485L10.3188 5.65148L14.1881 6.48936L11.5503 9.44155L11.4034 9.60585L11.4256 9.82506L11.8244 13.7639L8.20161 12.1675L7.99999 12.0786L7.79837 12.1675L4.17553 13.7639L4.57434 9.82506L4.59653 9.60585L4.44973 9.44155L1.81189 6.48936L5.6812 5.65148L5.89654 5.60485L6.00743 5.41445L7.99999 1.99344L9.99255 5.41445Z"
            stroke="currentColor"
        />
    </svg>
);

export default Icon;
